import React from 'react'
import { Container } from 'react-bootstrap'
import LayoutHeader from './Layout.header'

const Layout = ({ children }) => {
	return (
		<div className='min-vh-100 d-flex flex-column'>
			<LayoutHeader />
			<main className='flex-grow-1 d-flex'>{children}</main>
			<footer className='text-light py-5'>
				<Container className='text-center'>
					© 2020 Mobitech International Inc. All Rights Reserved
				</Container>
			</footer>
		</div>
	)
}

export default Layout
